<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover table-nowrap">
        <thead class="thead-light">
        <tr>
          <th scope="col">{{ $t('Position') }}</th>
          <th scope="col">{{ $t('Name') }}</th>
          <th scope="col">{{ $t('Category') }}</th>
        </tr>
        </thead>
        <draggable
            tag="tbody"
            v-model="services"
            @start="drag=true"
            @end="onEnd"
            item-key="id">
          <template #item="{index,element}">
            <tr class="order-row">
              <td>{{ index + 1 }}</td>
              <td>{{ element.name }}</td>
              <td>{{ element.category }}</td>
            </tr>
          </template>
        </draggable>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {draggable},
  data: function () {
    return {
      drag: false,
      services: []
    }
  },
  methods: {
    onEnd() {
      this.drag = false;
      this.postServicesOrder();
    },
    getServices() {
      axios.get('/api/admin/services').then(res => {
        this.services = res.data.data;
      });
    },
    postServicesOrder() {
      const order_list = this.services.map(function (service) {
        return service.id;
      });

      const data = {
        "order": order_list
      }

      axios.post('/api/admin/services/order', data).then(res => {
        console.log('re-ordered')
      });
    }
  },
  mounted() {
    this.getServices();
  }
}
</script>

<style scoped>
.order-row {
  cursor: grab;
}
</style>
